import React, { useState } from 'react'
import { API_URL } from '../../api'

const EmailSettings = () => {
    const [email, setEmail] = useState('')
    const [subscribed, setSubscribed] = useState(false)
    const [loaded, setLoaded] = useState(false)
    const [message, setMessage] = useState('')

    const loadPreferences = async () => {
        setMessage('')
        try {
            const res = await fetch(`${API_URL}/subscribers/${encodeURIComponent(email)}`)
            if (res.ok) {
                const data = await res.json()
                if (data && typeof data.subscribed === 'boolean') {
                    setSubscribed(data.subscribed)
                }
                setLoaded(true)
            } else {
                setMessage('Email not found')
            }
        } catch (err) {
            setMessage('Error loading preferences')
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setMessage('')
        try {
            const res = await fetch(`${API_URL}/subscribers/${encodeURIComponent(email)}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ subscribed })
            })
            if (res.ok) {
                setMessage('Preferences updated')
            } else {
                setMessage('Update failed')
            }
        } catch (err) {
            setMessage('Update failed')
        }
    }

    return (
        <div className="p-8 space-y-4 text-center">
            <h2 className="text-2xl font-bold mb-4">Email Settings</h2>
            {!loaded ? (
                <div className="flex flex-col items-center space-y-2">
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email" className="p-2 border border-gray-300 rounded w-1/2" />
                    <button onClick={loadPreferences} className="bg-blue-500 text-white font-bold py-2 px-4 rounded">Load Preferences</button>
                </div>
            ) : (
                <form onSubmit={handleSubmit} className="flex flex-col items-center space-y-2">
                    <label className="flex items-center space-x-2">
                        <input type="checkbox" checked={subscribed} onChange={(e) => setSubscribed(e.target.checked)} />
                        <span>Subscribe to updates</span>
                    </label>
                    <button type="submit" className="bg-green-500 text-white font-bold py-2 px-4 rounded">Save</button>
                </form>
            )}
            {message && <p>{message}</p>}
        </div>
    )
}

export default EmailSettings

